import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'

export default {
  name: 'change-bag-seal',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading
  },
  props: [],
  data() {
    return {
      isLoadingSearch: false,
      isLoading: false,
      hubzoneLoading: '',
      hubLoading: '',
      flthubLoading:'',
      rowNumber: '',
      hubzone: '',
      hub: '',
      RowListData: [],
      hubzonelist: [],
      hublist: [],
      hublistFlt: [],
      listHubZoneData: [],
      hubname: '',
      hubFlt: '',
      hubzoneidflt1: '',
      listHubZoneObjDataFlt1: {
        value: '',
        text: ''
      },
      hubzoneitem: {
        id: '',
        text: ''
      },
      hubitemFlt: {
        value: '',
        text: ''
      },
      hubitem: {
        value: '',
        text: ''
      },
      pageCount: 0,
      pageNo: 0,
      totalRows: 0,
      limit: 10,
      userHubid: '',
      createdby:'',
      updateModal: false,
      modaldata: '',
      hubzoneitemForUpdate:{
        value: '',
        text: ''
      },
      hubZoneForUpdate:'',
      hubItemForUpdate:{
        value: '',
        text: ''
      },
      hubNameForUpdate:'',
      rowNumberForUpdate:'',
      HubZoneListDataForUpdate:[],
      HubDetailsForUpdate:[],
      rowNoErrorMSG:'',
      rowNoError:false,
      hubZoneError:false,
      hubZoneErrorMsg:'',
      hubNameError:false,
      hubNameErrorMsg:'',
      regexForRowNumber:/^[a-zA-Z0-9]{1,30}$/,
      rowUpdateError:0,
      statusmodal:false,
      modalDataForStatus:[]

    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdby = userdetail[0].email
    this.userHubid = userdetail[0].HubId[0]
    this.getHubZone();

  },
  methods: {
    selectHubZoneForUpdate(hubzoneitem) {
      this.hubzoneitemForUpdate = hubzoneitem
      this.hubZoneForUpdate = this.hubzoneitemForUpdate.id
      this.hublist = []
      this.hubitem = {
        value: '',
        text: ''
      }
      this.hub = ''
      this.$validator.reset()
      if (this.hubZoneForUpdate != undefined) {
        this.getHubListForFilterUpdate()
      }
    },
    selectHubForUpdate(hubitem) {
      this.hubItemForUpdate = hubitem
      this.hubNameForUpdate = hubitem.value
    },
    getHubZone() {
      this.hubzoneLoading = 'Loading Hub Zone...'
      var HubZoneListData = []
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubzone/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubzoneLoading = ''
          if (result.data.ResultCode == 100) {
          HubZoneListData = result.data.ResponseData;
          for (var i = 0; i < HubZoneListData.length; i++) {
            this.hubzonelist.push({
              id: HubZoneListData[i].hubzoneid,
              text: HubZoneListData[i].hubzonename
            })
            this.listHubZoneData.push({
              id: HubZoneListData[i].hubzoneid,
              text: HubZoneListData[i].hubzonename
            })
          }
        }
        else{
          HubZoneListData = []
        }
        }, error => {
          this.hubzoneLoading = ''
          console.error(error)
        })
    },
    selectHubZone(hubzoneitem) {
      this.hubzoneitem = hubzoneitem
      this.hubzone = this.hubzoneitem.text
      this.hubzoneid = this.hubzoneitem.id
      this.hublist = []
      this.hubitem = {
        value: '',
        text: ''
      }
      this.hub = ''
      this.$validator.reset()
      if (this.hubzoneid != undefined) {
        this.getHubList()
      }
    },
    selectedHubZoneFlt1(listHubZoneObjDataFlt1) {
      this.listHubZoneObjDataFlt1 = listHubZoneObjDataFlt1
      this.hubzoneidflt1 = listHubZoneObjDataFlt1.text
      this.hubzoneid = listHubZoneObjDataFlt1.id
      this.hublistFlt = []
      this.hubitemFlt = {
        value: '',
        text: ''
      }
      this.hubFlt = ''
      this.$validator.reset()
      if (this.hubzoneid != undefined) {
        this.getHubListForFilter('IsSearch')
      }
    },
    getHubList(type) {
        this.hubLoading = 'Loading Hub...'
        var hubzone = this.hubzoneitem.id

      this.hublist=[]
      var HubDetails = []
      this.input = ({
        hubZoneId: hubzone
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          this.flthubLoading = ''
          if (result.data.ResultCode == 100) {
            HubDetails = result.data.ResponseData
            for (var i = 0; i < HubDetails.length; i++) {
              this.hublist.push({
                "value": HubDetails[i].HubID,
                "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
              })
              this.hublistFlt.push({
                "value": HubDetails[i].HubID,
                "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
              })
            }
          }
          else{
            HubDetails = []
          }
        }, error => {
          this.hubLoading = ''
          this.flthubLoading = ''
          console.error(error)
        })
    },
    getHubListForFilter(type) {
        this.hubLoading = 'Loading Hub...'
        var hubzone = this.listHubZoneObjDataFlt1.id
      this.hublistFlt=[]
      var HubDetails = []
      this.input = ({
        hubZoneId: hubzone
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          this.flthubLoading = ''
          if (result.data.ResultCode == 100) {
            HubDetails = result.data.ResponseData
            for (var i = 0; i < HubDetails.length; i++) {

              this.hublistFlt.push({
                "value": HubDetails[i].HubID,
                "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
              })
            }
          }
          else{
            HubDetails = []
          }
        }, error => {
          this.hubLoading = ''
          this.flthubLoading = ''
          console.error(error)
        })
    },
    getHubListForFilterUpdate(type) {
      if(this.hubZoneForUpdate){
        var hubzone = this.hubZoneForUpdate
      }
      this.HubDetailsForUpdate=[]
      this.flthubLoading = 'Loading Hub...'

      var HubDetails = []
      this.input = ({
        hubZoneId: hubzone
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          this.flthubLoading = ''
          if (result.data.ResultCode == 100) {
            HubDetails = result.data.ResponseData
            for (var i = 0; i < HubDetails.length; i++) {

              this.HubDetailsForUpdate.push({
                "value": HubDetails[i].HubID,
                "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
              })
            }
          }
          else{
            HubDetails = []
          }
        }, error => {
          this.hubLoading = ''
          this.flthubLoading = ''
          console.error(error)
        })
    },

    selectHub(hubitem) {
      this.hubitem = hubitem
      this.hub = hubitem.text
    },
    selectHubFlt(hubitem) {
      this.hubitemFlt = hubitem
      this.hubFlt = hubitem.text
    },
    createRow() {
      this.rowNoError=0;
      this.rowNoErrorMSG="";
      if(this.rowNumber && this.regexForRowNumber.test(this.rowNumber.trim()) == false)
      {
        this.rowNoError=1;
        this.rowNoErrorMSG="Row Number Must Be AlphaNumeric";
        return false;
      }
      this.isLoading = true;

      this.input = ({
        "hubId": this.hubitem.value,
        "rowNumber": this.rowNumber,
        "createdBy": this.createdby,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'addRowLocation',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");

            this.resetForm();

          } else {
            //  this.$alertify.error(result.data.ReturnMessage)
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          console.error(error)
        })
    },
    resetFlt() {
      this.totalRows=0
      this.RowListData=[]
      this.hubzoneidflt1 = ''
      this.hubFlt = '',
        this.hubitemFlt = {
          value: '',
          text: ''
        },
        this.listHubZoneObjDataFlt1 = {
          value: '',
          text: ''
        }
				this.$validator.reset();
    },
    resetForm() {
      this.rowNoError=0;
      this.rowNoErrorMSG="";
      this.totalRows = 0;
      this.pageCount = 0;
      this.hubzone = "";
      this.hub = "";
      this.rowNumber = "";
      this.hubzoneitem = {
          id: '',
          text: ''
        },
        this.hubitem = {
          value: '',
          text: ''
        },
        this.$validator.reset();
    },
    getRowList() {
      this.isLoadingSearch = true;
      this.input = ({});
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'listRowMaster?hubId=' + this.hubitemFlt.value + '&offset=' + this.pageNo + '&limit=' + this.limit,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoadingSearch = false;
					if(result.data.ResultCode == 100){
          this.RowListData = result.data.ResponseData;
          this.totalRows = result.data.TotalCount
          if (this.totalRows < 10) {
            this.pageCount = 1
          } else {
            this.pageCount = Math.ceil(this.totalRows / 10);
          }
				}
				else{
					this.RowListData = []
					this.totalRows = 0
					this.$alertify.error(result.data.ReturnMessage)
				}
        }, error => {
          console.error(error)
        })
    },
    updateRow() {
      this.rowUpdateError=0;
      if(!this.hubNameForUpdate)
      {
        this.hubNameError=true;
        this.hubNameErrorMsg='Select Hub Name';
        this.rowUpdateError=1;
      }
      if(!this.rowNumberForUpdate.trim() || this.rowNumberForUpdate.trim()=="")
      {
        this.rowNoError=true;
        this.rowNoErrorMSG='Enter Row Number';
        this.rowUpdateError=1;
      }
      if(this.regexForRowNumber && this.regexForRowNumber.test(this.rowNumberForUpdate.trim()) == false)
      {
        this.rowNoError=1;
        this.rowNoErrorMSG="Row Number Must Be AlphaNumeric";
        this.rowUpdateError=1;
      }
      if(this.rowUpdateError==1){
        return false;
      }
      this.input = ({
        "locationRowMasterId": this.modaldata.locationrowmasterid,
        "rowNumber": this.rowNumberForUpdate.trim(),
        "hubId": this.hubNameForUpdate,
        "isActive": this.modaldata.isactive,
        "LastModifiedBy": this.createdby
      })
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + 'updateRow',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            this.closeUpdateRowModal();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          console.error(error)
        })
    },
		openUpdateRowModal(data){
      this.hubNameForUpdate=data.hubid,
      this.rowNumberForUpdate=data.rownumber
      this.hubzoneLoading = 'Loading Hub Zone...'
      if(data.hubid)
      {
        this.input = ({
          id: data.hubid
        })
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/hub/get',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubzoneLoading = ''
          if (result.data.ResultCode == 100) {
          this.HubZoneListDataForUpdate = result.data.ResponseData[0];
          this.hubItemForUpdate={
            value: this.HubZoneListDataForUpdate.HubID,
            text: this.HubZoneListDataForUpdate.HubName
          };
          this.hubzoneitemForUpdate={
            value: this.HubZoneListDataForUpdate.HubZoneId,
            text: this.HubZoneListDataForUpdate.hubzonename
          };
        }
        else{
          this.HubZoneListDataForUpdate = []
        }
        }, error => {
          this.hubzoneLoading = ''
          console.error(error)
        })


			this.updateModal = true
			this.modaldata = data
		},
		closeUpdateRowModal(){
      this.rowNoError=false;
      this.rowNoErrorMSG='';
      this.updateModal = false
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
			this.getRowList()
		},
    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1)
      this.getRowList()
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        } else {
          this.createRow();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    onSubmitFlt: function(Flt) {
      this.$validator.validateAll('Flt').then((result) => {
        if (!result) {
          return false;
        } else {
          this.getRowList();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    openStatusModal(data) {
      this.statusmodal = true
      this.modalDataForStatus = data
    },
    closeStatusModal() {
      this.statusmodal = false,
      this.modalDataForStatus=[],
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
      this.getRowList();
    },
    UpdateRowStatus(){
      var newStatus=this.modalDataForStatus.isactive?0:1;
      this.input = ({
        "locationRowMasterId": this.modalDataForStatus.locationrowmasterid,
        "isActive": newStatus,
        "LastModifiedBy":this.createdby
      })
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + 'updateRowStatus',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            this.closeStatusModal();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          console.error(error)
        })

    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/rowMaster/rowMaster.js